module.exports = __webpack_public_path__ + "301c52eea4cb77f02a62b2366b2d1fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalHeader/logo_desktop.png
// module id = 1181
// module chunks = 7